import { OccasionalSlot, OccasionalSlotPriorityChild, OccasionalSlotPriorityGroup } from '@/types/Slots'

export type PriorityValue = { type: 'group'; id: number } | { type: 'child'; id: number }

export interface ParsedPriorityValues {
    groupIds: number[]
    childIds: number[]
}

export function parsePriorityValues(values: PriorityValue[]): ParsedPriorityValues {
    const groupIds: number[] = []
    const childIds: number[] = []

    for (const value of values) {
        switch (value.type) {
            case 'child': {
                childIds.push(value.id)
                break
            }
            case 'group': {
                groupIds.push(value.id)
                break
            }
        }
    }

    return { groupIds, childIds }
}

export function getPriorityValuesFromSlot(occasionalSlot?: OccasionalSlot): PriorityValue[] {
    if (!occasionalSlot) return []

    return [
        ...(occasionalSlot.priorityGroup ?? []).map(
            (group: OccasionalSlotPriorityGroup): PriorityValue => ({ type: 'group', id: group.id })
        ),
        ...(occasionalSlot.priorityChild ?? []).map(
            (child: OccasionalSlotPriorityChild): PriorityValue => ({ type: 'child', id: child.id })
        )
    ]
}
